export const ContentLibraryBase = ({ label = '' }) => ({
  label,
})
